import { LivingConditionsContainer } from '../../containers/advancedFilters/LivingConditionsContainer';
import { IFilter } from '../../types/advancedFilters';

export const livingConditions: IFilter = {
  component: LivingConditionsContainer,
};
